import moment from 'moment';

export const formatDates = (
  startDate: Date,
  endDate?: Date
): {
  formattedStartDate: string;
  formattedEndDate: string;
} => {
  const formattedStartDate = moment(startDate).format('MMM YYYY');
  const formattedEndDate = endDate
    ? moment(endDate).format('MMM YYYY')
    : 'Present';
  return { formattedStartDate, formattedEndDate };
};
